import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../store';
import * as courseAPI from 'api/schoolBasedActivity';
import {
  get_list_v2_params,
  batch_delete_course_params,
  batch_archive_params
} from 'types/schoolBasedActivity';
import { start } from 'nprogress';

// ----------------------------------------------------------------------

type CurriculumActivitiesState = {
  loading: boolean;
  activityList: any[];
  total: number;
  deleteLoading: boolean;
  activityInfo: {};
  getInfoLoading: boolean;
};

const initialState: CurriculumActivitiesState = {
  loading: false,
  activityList: [],
  total: 0,
  deleteLoading: false,
  activityInfo: {},
  getInfoLoading: false
};

const slice = createSlice({
  name: 'curriculumActivities',
  initialState,
  reducers: {
    startLoading(state) {
      state.loading = true;
    },
    stopLoading(state) {
      state.loading = false;
    },
    startDeleteLoading(state) {
      state.deleteLoading = true;
    },
    stopDeleteLoading(state) {
      state.deleteLoading = false;
    },
    startGetInfoLoading(state) {
      state.getInfoLoading = true;
    },
    stopGetInfoLoading(state) {
      state.getInfoLoading = false;
    },

    setActivityList(state, action) {
      state.loading = false;
      state.activityList = action.payload.rows || [];
      state.total = action.payload.total || 0;
    },
    removeActivity(state, action) {
      state.loading = false;
      state.activityList = state.activityList.filter((item) => item.id !== action.payload);
      state.total = Math.max(0, state.total - 1);
    },
    removeActivities(state, action) {
      state.loading = false;
      state.activityList = state.activityList.filter((item) => !action.payload.includes(item.id));
      state.total = Math.max(0, state.total - action.payload.length);
    },
    updateActivityStatus(state, action) {
      state.loading = false;
      const { ids, status } = action.payload;
      state.activityList = state.activityList.map((item) =>
        ids.includes(item.id) ? { ...item, status } : item
      );
    },
    setActivityInfo(state, action) {
      state.activityInfo = action.payload;
    }
  }
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------
// Actions
export const {
  startLoading,
  stopLoading,
  startGetInfoLoading,
  stopGetInfoLoading,
  setActivityList,
  removeActivity,
  removeActivities,
  updateActivityStatus,
  setActivityInfo
} = slice.actions;

// action

// 獲取課程活動列表
export function getActivityList(params: get_list_v2_params) {
  return async () => {
    dispatch(slice.actions.startLoading());
    const { callback, finalCallback } = params;
    try {
      const response = await courseAPI.get_list_v2(params);
      // console.log('getActivityList response:', response);

      if (callback) {
        callback(response);
      }

      if (!Array.isArray(response?.rows)) {
        return;
      }

      dispatch(slice.actions.setActivityList(response));
    } catch (error) {
      console.error('getActivityList error:', error);
    } finally {
      dispatch(slice.actions.stopLoading());
      if (finalCallback) {
        finalCallback();
      }
    }
  };
}

// 批量刪除課程活動
export function batchDeleteActivities(params: batch_delete_course_params) {
  return async () => {
    const { callback } = params;

    try {
      const response = await courseAPI.batch_delete_course(params);
      // console.log('batchDeleteActivities response:', response);

      // // 从本地列表中移除已删除的项目
      // dispatch(slice.actions.removeActivities(params.course_ids));

      if (callback) {
        callback(response);
      }
    } catch (error) {
      console.error('batchDeleteActivities error:', error);
      throw error;
    }
  };
}

// 單個刪除課程活動
export function deleteActivity(course_id: string, callback?: (response: any) => void) {
  return async () => {
    dispatch(slice.actions.startDeleteLoading());
    try {
      const response = await courseAPI.batch_delete_course({ course_ids: [course_id] });
      // console.log('deleteActivity response:', response);

      // // 从本地列表中移除已删除的项目
      // dispatch(slice.actions.removeActivity(Number(course_id)));

      if (callback) {
        callback(response);
      }
    } catch (error) {
      console.error('deleteActivity error:', error);
      throw error;
    } finally {
      dispatch(slice.actions.stopDeleteLoading());
    }
  };
}

// 批量歸檔（更改狀態）
export function batchArchiveActivities(params: batch_archive_params) {
  return async () => {
    const { callback, ...rest } = params;

    try {
      const response = await courseAPI.batch_archive(rest);
      // console.log('batchArchiveActivities response:', response);

      // // 更新本地列表中的状态
      // dispatch(slice.actions.updateActivityStatus({ ids: rest.course_ids, status: rest.status }));

      if (callback) {
        callback(response);
      }
    } catch (error) {
      console.error('batchArchiveActivities error:', error);
      throw error;
    }
  };
}
export function getInfoAction(id: string, callback?: (response: any) => void) {
  return async () => {
    dispatch(slice.actions.startGetInfoLoading());
    try {
      const response = await courseAPI.get({ id });
      dispatch(slice.actions.setActivityInfo(response || {}));
      if (callback) {
        callback(response);
      }
    } catch (error) {
      console.error('getInfoAction error:', error);
      dispatch(slice.actions.setActivityInfo({}));
      if (callback) {
        callback({});
      }
    } finally {
      dispatch(slice.actions.stopGetInfoLoading());
    }
  };
}
